/**
 * Open up a popup and print
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/events/on/on.js";

export default obj => {
	obj.on("click", function (e) {
		const win = window.open($(this).attr("href"), "", "left=0,top=0,width=800,height=600,toolbar=0,status=0");
		win.onload = () => {
			win.setTimeout(() => {
				win.focus();
				win.print();
				win.close();
			}, 500);
		};
		e.preventDefault();
	});
};
